import { render, staticRenderFns } from "./Senser.vue?vue&type=template&id=3b51bfb3&scoped=true&"
import script from "./Senser.vue?vue&type=script&lang=js&"
export * from "./Senser.vue?vue&type=script&lang=js&"
import style0 from "./Senser.vue?vue&type=style&index=0&id=3b51bfb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b51bfb3",
  null
  
)

export default component.exports